export default __webpack_public_path__ + "static/media/dashboard-eye.4516e108.svg";